"use client";

import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
	const { theme = "system" } = useTheme();

	return (
		<Sonner
			theme={theme as ToasterProps["theme"]}
			className="toaster group"
			// On a phone the message sits at the top, clear of the bottom bar that can cover it; the offset clears the status bar (the safe area).
			position={typeof window !== "undefined" && window.matchMedia?.("(max-width: 640px)").matches ? "top-center" : "bottom-right"}
			offset={typeof window !== "undefined" && window.matchMedia?.("(max-width: 640px)").matches ? "calc(env(safe-area-inset-top, 0px) + 12px)" : 20}
			toastOptions={{
				classNames: {
					toast:
						"group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
					description: "group-[.toast]:text-muted-foreground",
					actionButton:
						"group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
					cancelButton:
						"group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
				},
			}}
			expand={false}
			closeButton
			richColors
			{...props}
		/>
	);
};

export { Toaster };
